<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div>
          <label for="">Период</label>
          <div class="flex">
            <date-range-picker
              ref="picker"
              opens="right"
              class="mr-2"
              @update="updateSelectDates"
              :ranges="ranges"
              :locale-data="date_locale"
              v-model="dateRange"
            >
              <template v-slot:input="picker" style="min-width: 350px;">
                Выбрать даты
              </template>
            </date-range-picker>
            <div>
              <div class="input-group">
                <MaskedInput
                  @change="updateDates"
                  :mask="mask"
                  :keepCharPositions="true"
                  class="form-control"
                  v-model="userDate.start"
                />
                <div class="input-group-prepend">
                  <span class="input-group-text">по</span>
                </div>
                <MaskedInput
                  @change="updateDates"
                  :mask="mask"
                  :keepCharPositions="true"
                  class="form-control"
                  v-model="userDate.end"
                />
                <LoadingButton
                  title="Показать"
                  :loading="loading"
                  :color="$constants.SUCCESS_COLOR"
                  :onClick="() => getRecords()"
                  className="btn btn-outline-success"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-content-between mt-2">
          <div>
            <label for="">Учитывать страны закупки</label>
            <multiselect
              v-model="includedCountries"
              :options="$AllCountries"
              track-by="name"
              label="name"
              :show-labels="false"
              placeholder="Выберите страны"
              :multiple="true">
            </multiselect>
          </div>
          <div>
            <label for="">Исключить страны закупки</label>
            <multiselect
              v-model="excludedCountries"
              :options="$AllCountries"
              track-by="name"
              label="name"
              :show-labels="false"
              placeholder="Выберите страны"
              :multiple="true">
            </multiselect>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="text-right">
          <paginate v-if="paginator"
                    v-model="paginator.current_page"
                    :page-count="paginator.last_page"
                    :page-range="3"
                    :margin-pages="2"
                    :click-handler="getRecords"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
        </div>
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>

        <template v-if="records">

          <div class="mb-1">
            <p class="mb-1">Всего - упаковок: <strong>{{
                Object.values(countriesSum).reduce((acc, c) => acc + c, 0)
              }}</strong> препаратов: <strong>{{ paginator.total }}</strong></p>
            <p class="mb-0" v-for="country in sortedCountries" v-if="countriesSum[country.id]">
              {{ country.name }}:
              <strong>{{ countriesSum[country.id] }}</strong>
            </p>
          </div>

          <table class="table table-sm table-hover">
            <thead>
            <tr>
              <th></th>
              <th>Препарат</th>
              <th>Упаковки</th>
              <th>Склад</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(record, i) in records">
              <td>{{ (i + 1) + ((currentPage - 1) * paginator.per_page) }}</td>
              <td>{{ record.title }}</td>
              <td>{{ record.total }}</td>
              <td>{{ Math.round(inStore[record.drug_id] || 0) }}</td>
            </tr>
            </tbody>
          </table>

          <div class="text-right">
            <paginate v-if="paginator"
                      v-model="paginator.current_page"
                      :page-count="paginator.last_page"
                      :page-range="3"
                      :margin-pages="2"
                      :click-handler="getRecords"
                      :prev-text="'&laquo'"
                      :next-text="'&raquo'"
                      :container-class="'pagination'"
                      :prev-class="'page-item'"
                      :prev-link-class="'page-link'"
                      :page-class="'page-item'"
                      :page-link-class="'page-link'"
                      :next-class="'page-item'"
                      :next-link-class="'page-link'"
                      :active-class="'active green_btn'">
            </paginate>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import DateRangePicker from 'vue2-daterange-picker'
import moment from "moment/moment";
import MaskedInput from 'vue-text-mask'
import LoadingButton from "@/components/buttons/LoadingButton";
import Multiselect from 'vue-multiselect'
import Paginate from 'vuejs-paginate'

export default {
  components: {
    DateRangePicker,
    MaskedInput,
    LoadingButton,
    Multiselect,
    Paginate,
  },
  computed: {
    $AllCountries() {
      return this.$store.getters['platform/countries'];
    },
  },
  data() {
    return {
      loading: false,
      paginator: null,
      currentPage: 1,
      includedCountries: [],
      excludedCountries: [],
      countriesSum: {},
      sortedCountries: {},
      records: null,
      inStore: {},
      mask: [/[0,1,2,3]/, /\d/, '.', /[0,1,2]/, /\d/, '.', /[2]/, /[0]/, /[1,2]/, /\d/],
      dateRange: {
        startDate: moment().startOf('isoWeek'),
        endDate: moment().endOf('isoWeek'),
      },
      userDate: {
        start: null,
        end: null
      },
      date_locale: {
        firstDay: 1,
        format: 'DD.MM.YYYY',
        applyLabel: 'Выбрать',
        cancelLabel: 'Отмена',
      },
      ranges: { //default value for ranges object (if you set this to false ranges will no be rendered)
        'Текущая неделя': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
        'Прошлая неделя': [moment().subtract(1, 'isoWeek').startOf('isoWeek'), moment().subtract(1, 'isoWeek').endOf('isoWeek')],
        'Текущий месяц': [moment().startOf('month'), moment().endOf('month')],
        'Прошлый месяц': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
    }
  },
  created() {
    this.updateSelectDates();
    this.sortedCountries = _.orderBy(this.$AllCountries, 'name');
    // this.sortedCountries = this.$AllCountries.reduce((acc, c) => {
    //   acc[c.id] = c;
    //   return acc;
    // }, {})
  },
  methods: {
    updateSelectDates() {
      this.userDate.start = moment(this.dateRange.startDate).format('DD.MM.YYYY')
      this.userDate.end = moment(this.dateRange.endDate).format('DD.MM.YYYY')
    },
    async getRecords(page = 1) {
      this.loading = true;
      let {data: r_data} = await api.post('/reports/countrydrugs?page=' + page, {
        dateRange: this.userDate,
        includedCountries: this.includedCountries.map((c) => c.id),
        excludedCountries: this.excludedCountries.map((c) => c.id)
      });
      if (r_data.success) {
        const {data, ...pagination} = r_data.records
        this.currentPage = pagination.current_page
        this.paginator = pagination;
        this.inStore = r_data.inStores;
        this.countriesSum = r_data.countriesSum;
        this.records = data;
      } else {
        toastr['warning']('Ошибка сервера');
      }
      this.loading = false;
    },
    updateDates() {
      const regex = /^\d{2}\.\d{2}\.\d{4}$/;
      if (!this.userDate.start.match(regex)) {
        this.userDate.start = moment(this.dateRange.startDate).format('DD.MM.YYYY')
        return;
      }
      if (!this.userDate.end.match(regex)) {
        this.userDate.end = moment(this.dateRange.endDate).format('DD.MM.YYYY')
        return;
      }
      this.dateRange.startDate = moment(this.userDate.start, 'DD.MM.YYYY')
      this.dateRange.endDate = moment(this.userDate.end, 'DD.MM.YYYY')
    }
  }
}
</script>
